import { z } from 'zod'
import type { StoreBasicInfo } from '../../models/AppSetting'

export const StoreBasicInfoDTOSchema = z.object({
  display_name: z.string().nullish(),
  description: z.string().nullable().optional(),
  timezone: z.string().nullable().optional(),
  slug: z.string().nullish()
})

export type StoreBasicInfoDTO = z.infer<typeof StoreBasicInfoDTOSchema>

export function mapDTOToStoreBasicInfo (dto: StoreBasicInfoDTO): StoreBasicInfo {
  return {
    name: dto.display_name ?? '',
    description: dto.description ?? undefined,
    timezone: dto.timezone ?? undefined,
    slug: dto.slug ?? null
  }
}

export function mapStoreBasicInfoToDTO (model: StoreBasicInfo): StoreBasicInfoDTO {
  return {
    display_name: model.name,
    description: model.description,
    timezone: model.timezone ?? null,
    slug: model.slug ?? null
  }
}
